<template>
  <bita-modal
    id="slide-form"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoading || isLoadingModal"
    @close="reset"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <!-- عنوان -->
            <bita-input
              type="text"
              name="title"
              label="عنوان"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.title"
            />

            <!-- آپلود تصویر -->
            <bita-uploader
              name="icon"
              label="تصویر"
              ref="uploader"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.image"
              :icon-url="formData.image_url"
            />

            <!-- ترتیب -->
            <bita-input
              type="number"
              name="order"
              min="0"
              label="ترتیب"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.order"
            />

            <!-- آدرس -->
            <bita-input
              type="text"
              name="link"
              label="آدرس"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.link"
            />

            <!-- نوع -->
            <div class="col-lg-4">
              <label for="typeSelect">نوع</label>
              <select
                id="typeSelect"
                class="form-control"
                v-model="formData.type"
                required
              >
                <option
                  v-for="type in typesSource"
                  :key="type.id"
                  :value="type.id"
                >
                  {{ type.name }}
                </option>
              </select>
            </div>

            <!-- کالکشن -->
            <div class="col-lg-4" v-if="formData.type == 5 || formData.type == 11">
              <label for="collectionSelect">کالکشن</label>
              <select
                id="collectionSelect"
                class="form-control"
                v-model="formData.meta_id"
                required
              >
                <option
                  v-for="c in collections"
                  :key="c.id"
                  :value="c.id"
                >
                  {{ c.title }}
                </option>
              </select>
            </div>

            <!-- اندازه -->
            <div class="col-lg-4" v-show="isProductPic">
              <label for="sizeSelect">اندازه</label>
              <select
                id="sizeSelect"
                class="form-control"
                v-model="formData.size"
                :required="isProductPic"
              >
                <option value="1">کوچک</option>
                <option value="2">متوسط</option>
                <option value="3">بزرگ</option>
                <option value="4">کوچک دوتایی</option>
              </select>
            </div>

            <!-- صفحه واسط -->
            <div class="col-lg-4" v-if="[12,13,14,15,16].includes(formData.type)">
              <label for="middlePagesSelect">صفحه واسط</label>
              <select
                id="middlePagesSelect"
                class="form-control"
                v-model="formData.meta_id"
                required
              >
                <option
                  v-for="m in middlePages"
                  :key="m.id"
                  :value="m.id"
                >
                  {{ m.title }}
                </option>
              </select>
            </div>
          </div>

          <!-- نمایش تصویر اگر موجود باشد -->
          <div class="row" v-if="formData.id && formData.image_url">
            <img :src="formData.image_url" alt="..." class="img-thumbnail" />
          </div>

          <!-- textarea css -->
          <bita-textarea
            type="text"
            name="css"
            label="css کد"
            :validation-container-class="colFullWidth"
            input-class="form-control"
            v-model="formData.meta_css"
            rowspan="5"
          />
        </div>
      </bita-form>
    </div>

    <div slot="footer">
      <bita-bootbutton
        v-if="!formData.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="save"
      />
      <bita-bootbutton
        v-else
        title="بروزرسانی"
        type="primary"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
    </div>
  </bita-modal>
</template>

<script>
import { productCollectionApi, mdidlePagesApi } from "@/api/apiManagement";

export default {
  props: {
    title: String,
    isLoading: Boolean,
    slide: Object,
  },
  data() {
    return {
      colWidth: "col-lg-4",
      formData: {},
      collections: [],
      middlePages: [],
      isLoadingModal: false,
    };
  },
  computed: {
    isProductPic() {
      return this.formData.type == 2 || this.formData.type == 5;
    },
    typesSource() {
      return [
        { id: 1, name: "اسلایدر" },
        { id: 2, name: "بنر وسط" },
        { id: 3, name: "بنر ساید بار" },
        { id: 4, name: "بنر سرصفحه" },
        { id: 5, name: "بنر کالکشن محصول" },
        { id: 6, name: "بنر سرصفحه موبایل" },
        { id: 7, name: "دسته بندی سر صفحه" },
        { id: 8, name: "اسلایدر حالت موبایل" },
        { id: 9, name: "بنر تخفیف ویژه موبایلی" },
        { id: 10, name: "بنر تخفیف ویژه دسکتاپ" },
        { id: 11, name: "دسته بندی بالای کالکشن" },
        { id: 12, name: "اسلایدر صفحه واسط" },
        { id: 13, name: "دسته بندی سرصفحه واسط" },
        { id: 14, name: "اسلایدر صفحه واسط حالت موبایل" },
        { id: 15, name: "بنر تخفیف ویژه موبایلی صفحه واسط" },
        { id: 16, name: "بنر تخفیف ویژه دسکتاپ صفحه واسط" },
      ];
    },
  },
  methods: {
    setForm(data = {}) {
      this.formData = { ...data };
      if (this.$acl.can("view", "product-collections")) {
        this.isLoadingModal = true;
        productCollectionApi
          .gets()
          .then((res) => {
            this.collections = res.data.entity;
          })
          .finally(() => (this.isLoadingModal = false));

        mdidlePagesApi
          .gets()
          .then((res) => {
            this.middlePages = res.data.entity;
          })
          .finally(() => (this.isLoadingModal = false));
      }
    },
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-create", this.formData);
        }
      });
    },
    update() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-update", this.formData);
        }
      });
    },
    reset() {
      this.formData = {};
      this.$refs.uploader.reset();
      this.$refs.form.reset();
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
  },
};
</script>
